import React from "react";
import { ResponsivePie } from "@nivo/pie";
import Legend from "../legend/Legend";
import BarLegend from "../bar-legend/BarLegend"; // NEW
import styles from "./DonutChart.module.css";

/**
 * DonutChart component
 * @param {array} data - The data to be displayed in the donut chart
 * @param {string} size - The size of the donut chart
 * @param {number} thickness - The thickness of the donut chart (0-1) default is 0.3
 * @param {boolean} legend - Whether to display the legend
 * @param {boolean} barLegend - Show the bar style legend (name, value, %, progress bar) and the matching donut style
 * @param {string} centerText - The text to be displayed in the center of the donut chart
 * @param {string} centerSubText - Small text under centerText (only used with barLegend)
 * @param {object} centerTextProps - Additional props to be passed to the center text
 */

const DonutChart = ({
  data,
  size,
  thickness = 0.3,
  legend,
  barLegend = false, // NEW
  centerText,
  centerSubText, // NEW
  centerTextProps,
  unit = "",
  gap,
  legendPadding,
  onDatumClick,
}) => {
  const innerRadius = 1 - thickness;

  const isLoading = !data || data.length === 0;

  return (
    <div className={styles.donutContainer} style={{ gap: gap || "0.8rem" }}>
      <div style={{ width: size, height: size }} className={styles.donutChart}>
        {isLoading ? (
          <div
            className="shimmer"
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "50%",
            }}
          />
        ) : (
          <>
            <ResponsivePie
              data={data}
              innerRadius={innerRadius}
              margin={{ top: 10, bottom: 10, left: 10, right: 10 }}
              activeOuterRadiusOffset={8}
              borderWidth={barLegend ? 0 : 1} // NEW
              borderColor={{
                from: "color",
                modifiers: [["darker", 0.2]],
              }}
              padAngle={barLegend ? 1.5 : 0} // NEW
              cornerRadius={barLegend ? 2 : 0} // NEW
              enableArcLinkLabels={false}
              enableArcLabels={false}
              enableRadialLabels={false}
              enableSliceLabels={false}
              colors={{ datum: "data.color" }}
              animate={true}
              onClick={
                onDatumClick
                  ? ({ data: datum }) => onDatumClick(datum)
                  : undefined
              }
            />

            {barLegend ? (
              // NEW: center text with a sub label
              <div className={styles.barCenter}>
                <span className={styles.barCenterValue}>{centerText}</span>
                {centerSubText && (
                  <span className={styles.barCenterSub}>{centerSubText}</span>
                )}
              </div>
            ) : (
              <div
                style={{
                  width: "4rem",
                  wordBreak: "break-word",
                }}
                {...centerTextProps}
                className={[
                  styles.donutCenterText,
                  centerTextProps?.className,
                ].join(" ")}
              >
                {centerText}
              </div>
            )}
          </>
        )}
      </div>

      {(legend || barLegend) && (
        <div className={styles.donutLegend} style={{ padding: legendPadding }}>
          {barLegend ? (
            <BarLegend
              data={data || []}
              unit={unit}
              onItemClick={onDatumClick}
            />
          ) : (
            <Legend
              direction="column"
              data={data}
              unit={unit}
              isLoading={isLoading}
              onItemClick={onDatumClick}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default DonutChart;